import classNames from 'classnames';
import React, { useCallback } from 'react';
import { CategoryColor } from '../../api/api.ts';
import { gradientClassesForColor } from '../../utils/Colors.ts';
import { Slider } from '@/components/ui/slider.tsx';
import cn from '@/utils/cn.ts';

// todo https://www.smashingmagazine.com/2021/12/create-custom-range-input-consistent-browsers/
export default function InputRange({
  value,
  min,
  max,
  step,
  onChange,
  onDisabledClick,
  disabled,
  labelFormat,
  className,
  labels,
}: {
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  onDisabledClick?: () => void;
  disabled: boolean;
  labelFormat?: (value: number) => string;
  className?: string;
  labels?: string[];
}) {
  if (labelFormat && labels)
    throw "Hardcoded 'labels' override 'labelFormat' callback, please only give one";
  if (labels && labels.length !== (max - min) / step + 1)
    throw 'Slider labels need to have the same length as the slider steps';
  const getLabel = useCallback(
    (value: number): string => {
      return !labels ? value.toString() : labels[(value - min) / step];
    },
    [value, labels]
  );
  return (
    <div
      className={classNames(
        'pb-[2em]',
        'relative',
        disabled ? 'cursor-pointer' : undefined
      )}
      onClick={(_e: React.MouseEvent) =>
        disabled && onDisabledClick && onDisabledClick()
      }
    >
      <Slider
        value={[!disabled ? value : Math.round((max - min) / 2 + min)]}
        min={min}
        max={max}
        step={step}
        onValueChange={(value) => onChange(value[0])}
        disabled={disabled}
        className={cn('my-[8px]')}
      />
      {disabled && (
        // cover the disabled input, otherwise it swallows the click events (for activating)
        <div className={classNames('absolute', 'inset-0')}></div>
      )}
      <div
        className={classNames(
          'absolute',
          'bottom-0',
          'left-0',
          'right-0',
          'w-full',
          'flex',
          'flex-row',
          'justify-between',
          'px-[6px]',
          'py-[3px]',
          'text-gray-400'
        )}
      >
        <span>
          {labels ? getLabel(min) : labelFormat ? labelFormat(min) : min}
        </span>
        <span>
          {labels ? getLabel(max) : labelFormat ? labelFormat(max) : max}
        </span>
      </div>
      {!disabled && (
        <span
          className={classNames(
            'absolute',
            'bottom-0',
            'left-1/2',
            'bg-gray-200',
            'px-[12px]',
            'py-[3px]',
            'rounded-[8px]'
          )}
          style={{
            left: `${Math.round(((value - min) / (max - min)) * 100)}%`,
            transform: `translateX(-${Math.round(
              ((value - min) / (max - min)) * 100
            )}%)`,
          }}
        >
          {labels ? getLabel(value) : labelFormat ? labelFormat(value) : value}
        </span>
      )}
    </div>
  );
}
